import { useFetch } from 'services/useFetch'
import { useState } from 'react'
import { constructOptionMultipleSelect } from 'utils/utils'
import { API_SALE_PAGE } from 'services/apiSalePage'
import { VoucherHighlight } from 'components/main-page/sale-page/voucher-highlight/VoucherHighlight'

export const VoucherHighlightContainer = ({ salePageDetail, onChangeForm, errorForm }) => {
    const { fetching: getVoucherList } = useFetch(API_SALE_PAGE.VOUCHER_LIST)
    const [optionsVoucher, setOptionsVoucher] = useState([])

    const onSearchVoucher = (keyword) => {
        getVoucherList({ search: keyword }).then((response) => {
            const newList = constructOptionMultipleSelect(response?.data, 'code', 'id', 'thumbnail')
            setOptionsVoucher(newList)
        })
    }

    const props = {
        salePageDetail,
        onSearchVoucher,
        optionsVoucher,
        onChangeForm,
        errorForm,
    }

    return <VoucherHighlight {...props} />
}
